var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3792 31.9888C25.0066 31.9888 32.0005 25.0351 32.0005 16.4573C32.0005 7.87947 25.0066 0.925781 16.3792 0.925781C7.75173 0.925781 0.757812 7.87947 0.757812 16.4573C0.757812 25.0351 7.75173 31.9888 16.3792 31.9888Z",
    stroke: "#B7B7B7",
    strokeWidth: 0.625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5654 21.0492L15.5526 17.1372H13.8789V15.4606H15.5526V14.3429C15.5526 12.8344 16.4852 12.1074 17.8285 12.1074C18.472 12.1074 19.0251 12.1554 19.1862 12.1769V13.7533L18.2545 13.7537C17.5239 13.7537 17.3825 14.1015 17.3825 14.6118V15.4606H19.458L18.9001 17.1372H17.3825V21.0492H15.5654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.e0877e9210caf63af7a0de93cad21b58.svg";
export { ForwardRef as ReactComponent };